<template>
  <v-container v-if="events_data" fluid>
    <v-row no-gutters class="my-4 mx-8 border-bottom">
      <v-col cols="8" class="mx-auto border-right">
        <div class="text-h6 primaryDark--text my-3">PQ Timeline</div>
        <div class="mr-4">
          <TimelineChart :data="events_timeline" :chartData="page_content.events_timeline" />
        </div>
      </v-col>
      <v-col cols="4">
        <RadialChartVT
          :v-if="events_data"
          :title="page_content.pq_issue_distrubution.title"
          :tooltip="page_content.pq_issue_distrubution.tooltip"
          :chartData="events_distribution"
          @on-click="apply_graph_filter($event)"
        />
      </v-col>
    </v-row>
    <EventsList :page_content="page_content" :events_list="filtered_events_list" @clear="current_filter = ''" />
  </v-container>
</template>

<script>
import { axios_get } from "../services/vt_service";
import { scv } from "../services/powerdata";
import { content } from "../../config/scavenger.js";

import EventsList from "./EventsList";
import TimelineChart from "./TimelineChart";
import RadialChartVT from "./RadialChartVT";

export default {
  name: "ScavengerAssetEvents",
  props: {
    device_id: String,
  },
  components: {
    EventsList,
    TimelineChart,
    RadialChartVT,
  },
  data: function () {
    return {
      page_content: null,
      events_data: null,
      current_filter: "",
    };
  },
  created() {
    this.page_content = content;
  },
  mounted() {
    this.get_scavenger_events();
  },
  methods: {
    async get_scavenger_events() {
      this.network_error = false;
      axios_get(scv.get_scavenger_events, { id: this.device_id }).then((response) => {
        this.events_data = response;
      });
    },
    apply_graph_filter(event) {
      this.current_filter = event;
    },
  },
  computed: {
    events_timeline() {
      var timeline_data = [];
      this.events_list.map((elem) => {
        timeline_data.push({
          start: elem.startTimestamp,
          end: elem.endTimestamp,
          key: `${elem.event_id}_${elem.subid}`,
          label: elem.eventType,
          type: elem.type,
          duration: elem.duration,
        });
      });
      return this.events_list ? timeline_data : null;
    },
    events_list() {
      let temp = {};
      this.events_data.map((e) => {
        if (e.event.endTimestamp && e.event.startTimestamp) {
          if (!temp[e.event_id + "_" + e.subid])
            temp[e.event_id + "_" + e.subid] = {
              deviceId: e.deviceId,
              eventType: e.eventType,
              type: this.page_content.events[e.eventType],
              messageType: e.messageType,
              id: `${e.event_id ? e.event_id : 0}_${e.subid}`,
              event_id: e.event_id,
              subid: e.subid,
              timestampISO: e.timestampISO,
              endTimestamp: e.event.endTimestamp,
              startTimestamp: e.event.startTimestamp,
              duration:
                e.event.endTimestamp - e.event.startTimestamp
                  ? (e.event.endTimestamp - e.event.startTimestamp) / 3600000
                  : 0,
              values: [],
            };
          temp[e.event_id + "_" + e.subid].values.push(e.event);
        }
      });
      let events = Object.keys(temp).map((e) => temp[e]);
      return this.events_data ? events : null;
    },
    filtered_events_list() {
      return this.events_list
        ? this.events_list.filter((e) =>
            this.current_filter ? e.eventType.toLowerCase() == this.current_filter.toLowerCase() : true
          )
        : null;
    },
    events_distribution() {
      var total = 0;
      var events = {
        RAPID_VOLTAGE_CHANGE: 0,
        DIP: 0,
        SWELL: 0,
        INTERRUPT: 0,
        LOSS_OF_MAINS: 0,
        FLICKER: 0,
      };
      var distribution_data = [this.page_content.pq_issue_distrubution.header];
      this.events_list.map((elem) => {
        events[elem.eventType] = events[elem.eventType] ? events[elem.eventType] + 1 : 1;
        total++;
      });
      this.page_content.pq_issue_distrubution.data.map((elem) => {
        let temp = [
          elem.value,
          events[elem.value],
          {
            msg: elem.msg,
            title: elem.label,
            footer: `${events[elem.value]}(${this.$numberFormat((events[elem.value] / total) * 100)}%)`,
          },
        ];
        events[elem.value] != 0 && distribution_data.push(temp);
      });
      return this.events_list ? distribution_data : null;
    },
  },
};
</script>
